module.exports = __webpack_public_path__ + "img/VetoSans-BoldItalic.8cc6ed2b.svg";